/* eslint-disable no-throw-literal */
import { APPOINTMENT_BOOKING_ENDPOINT, APPOINTMENT_ENDPOINT, CONTACT_INFORMATION_ENDPOINT, MEDICAL_HISTORY_ENDPOINT, PATIENT_DETAIL_ENDPOINT, PATIENT_ENDPOINT, PATIENT_SEARCH_ENDPOINT, REFERRAL_DETAILS_ENDPOINT } from "../config/api-endpoints"
import { authorizeHeader } from "../utils/auth-header"

export const getPatientDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = PATIENT_SEARCH_ENDPOINT
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getAppointmentPatientDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = APPOINTMENT_BOOKING_ENDPOINT + "/patient/search"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const deletePatientAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    let endpointToHit = PATIENT_DETAIL_ENDPOINT +`/${requestBody}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}
export const postMedicalDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = MEDICAL_HISTORY_ENDPOINT 
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const putMedicalDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = MEDICAL_HISTORY_ENDPOINT + `/${requestBody.id}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getMedicalDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = MEDICAL_HISTORY_ENDPOINT + "/search" 
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const createPatientDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = PATIENT_ENDPOINT 
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const putPatientDetailAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    }

    let endpointToHit = `${PATIENT_ENDPOINT}/${requestBody.patient_id}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const deleteAppointmentAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    let endpointToHit = APPOINTMENT_ENDPOINT + `/${requestBody}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const createContactInformationAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = CONTACT_INFORMATION_ENDPOINT 
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const putContactInformationAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = CONTACT_INFORMATION_ENDPOINT + `/${requestBody.id}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getContactInformationAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = CONTACT_INFORMATION_ENDPOINT  + "/search"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const referralDetailsAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(requestBody)
    }
    let endpointToHit = REFERRAL_DETAILS_ENDPOINT 
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const patientDetailsAPICall = async (requestBody) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }

    let endpointToHit = PATIENT_ENDPOINT + `/${requestBody}`
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getAppointmentDetailAPICall = async (payload) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload ? payload: {})
    }
    
    let endpointToHit = APPOINTMENT_ENDPOINT + "/search"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getAppointmentNoShowAPICall = async (payload) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
    }
    
    let endpointToHit = APPOINTMENT_ENDPOINT + "/update_no_show"
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

